import { render, staticRenderFns } from "./AddPortNumber.vue?vue&type=template&id=da53d2e4&"
import script from "./AddPortNumber.vue?vue&type=script&lang=js&"
export * from "./AddPortNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports